<template lang="html">
    <div class="editor">
        <div ref="toolbar" class="toolbar"  style="width:1000px">
          <div class="insertContent" @click='contentCallback'><i class="el-icon-plus">添加内容项</i></div>
          <div class="insertHouse" @click='houseCallback'><i class="el-icon-plus">插入楼盘</i></div>
        </div>
        <div ref="editor" class="text" style="height:700px;width:1000px">
        </div>
    </div>
</template>

<script>
import { readImage } from "@/utils/imgCompress.js";

import { uploadFile } from '@/service/wikipedia'
import { UPLOAD_CODE } from "@/config/index";
import E from "wangeditor";
export default {
  name: "editoritem",
  data() {
    return {
      // uploadPath,
      editor: null,
      info_: null,
      editorId:null,
      txtValue:'',
    };
  },
  model: {
    prop: "value",
    event: "change,showHouseAdd"
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    isClear: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    isClear(val) {
      // 触发清除文本域内容
      if (val) {
        this.editor.txt.clear();
        this.info_ = null;
      }
    },
    value: function(value) {
     
      if (value !== this.editor.txt.html()) {
         this.txtValue = value;
        this.editor.txt.html(this.txtValue);
      }
    }
    //value为编辑框输入的内容，这里我监听了一下值，当父组件调用得时候，如果给value赋值了，子组件将会显示父组件赋给的值
  },

  mounted() {
    this.seteditor();
    this.editor.txt.html(this.txtValue);
  },
  methods: {

    seteditor() {
      if (process.env.NODE_ENV === 'development') { 
          this.uploadUrl =process.env.VUE_APP_UPLOAD_ACTION;
      }else{
         this.uploadUrl = window.serverConfig[window.siteMap[domain]].VUE_APP_UPLOAD_ACTION;;
      }
      this.editor = new E(this.$refs.toolbar, this.$refs.editor);
      this.editor.customConfig = this.editor.customConfig
        ? this.editor.customConfig
        : this.editor.config;
      this.editor.customConfig.uploadImgShowBase64 = false; // base 64 存储图片
      this.editor.customConfig.uploadImgServer =this.uploadUrl
         // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {}; // 自定义 header
      this.editor.customConfig.uploadFileName = "file"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 10 * 1024 * 1024; // 将图片大小限制为 10M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // 配置菜单
      this.editor.customConfig.menus = [
        "head", // 标题
        "bold", // 粗体
        //"fontSize", // 字号
        // 'fontName', // 字体
        //"italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo", // 重复
        "fullscreen", // 全屏
        //'house'
      ];
      let self = this;
      //this.editor.customConfig.pasteFilterStyle = true;
      self.editor.customConfig.customUploadImg = function(files, insert) {
        readImage(files[0]).then(res => {
          self.postImg(res, insert);
        });
      };
      self.editor.customConfig.onchange = html => {
        self.info_ = html; // 绑定当前逐渐地值
        self.$emit("change", this.info_); // 将内容同步到父组件中
      };

      self.editor.customConfig.houseCallback=function(){
        self.insertHouseInfo(data)
        console.log('点击了自定义菜单')
      }
      self.editor.customConfig.contentCallback=function(){
        //self.insertContentInfo(data)
        console.log('点击了自定义菜单')
      }
      // 创建富文本编辑器
      self.editor.create();
    },
    houseCallback(){
      this.$emit('showHouseAdd')
    },
    contentCallback(){
         this.$emit('handleAddCnt3')
    },
    insertHouseInfo(data){
        let _imgReg =/<i class="el-icon-office-building houseUnit" [^>]*>[^<]*<\/i>/gi;
        let _imgArr = this.editor.txt.html().match(_imgReg)
        if(_imgArr && _imgArr.length){
         this.editor.txt.html(this.editor.txt.html().replace(_imgArr[0],""))
        }
        this.editor.cmd.do('insertHTML', '&nbsp;&nbsp;<i class="el-icon-office-building houseUnit" data-rcid="'+data.id+'">'+data.rules_name+',数量'+data.num+'</i>&nbsp;&nbsp;');
    },
    insertContentInfo(data){
      let newA = [];
      data.forEach(el => {
          el = '<p>'+el+'</p>';
          newA.push(el)
        });
      var a = newA.join(" ")  
      this.editor.cmd.do('insertHTML', a);

    },
    async postImg(files, insert) {
      // files是input中选中的文件列表
      const formData = new FormData();
      formData.append("file", files);
      formData.append("code", UPLOAD_CODE.news);
      const res = await uploadFile(UPLOAD_CODE.news, formData);
      var imgUrl ="https://"+res.full_url+"!watermark"; //后台返回的文件路径
      insert(imgUrl); //生成img标签并插入文章中
    }
  }
};
</script>

<style lang="css">
.editor {
  width: 100%;
  position: relative;
  z-index: 0;
  text-align: left;
}
.toolbar {
  border: 1px solid #ccc;
}
.text {
  border: 1px solid #ccc;
}
.w-e-text img{
  max-width:100%;
}
.insertHouse{
  position: absolute!important;
  right:20px;
  z-index: 99999;
  cursor: pointer;
}
.insertContent{
  position: absolute!important;
  right:110px;
  z-index: 99999;
  cursor: pointer;
}
.houseUnit{
    border: 1px solid #999;
    padding: 10px;
}
br{
  display: inline;
}
.el-icon-office-building:before{
    font-size: 30px;
    color: #409EFF;
}
.w-e-toolbar .w-e-menu {
    position: relative;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
}
</style>